import { LinkedAccount, LinkedAccountSyncSelections } from "../../../../../../models/Entities";
import { useRequest } from "../../../../../shared/hooks/useRequest";

type UseLoadLinkedAccountSyncSelectionsProps = {
  linkedAccount: LinkedAccount;
};

const useLoadLinkedAccountSyncSelections = ({
  linkedAccount,
}: UseLoadLinkedAccountSyncSelectionsProps) => {
  // derived state
  const linkedAccountSyncSelectionsPath = `integrations/selective-sync/linked-account/${linkedAccount.id}/sync-selections`;

  const { loading: linkedAccountSyncSelectionsLoading, data: linkedAccountSyncSelections } =
    useRequest<LinkedAccountSyncSelections>({
      path: linkedAccountSyncSelectionsPath,
      errorText: "Error loading linked account sync selections",
    });

  return {
    linkedAccountSyncSelections,
    loading: linkedAccountSyncSelectionsLoading,
  };
};

export default useLoadLinkedAccountSyncSelections;
